// This file was auto-generated by Fern from our API Definition.
export var WebhookSubscriptionData;
(function (WebhookSubscriptionData) {
    WebhookSubscriptionData.AuthMode = {
        Signature: "signature",
        Authorization: "authorization",
    };
})(WebhookSubscriptionData || (WebhookSubscriptionData = {}));
